import {
    Box,
    Icon,
    IconButton,
    IOption,
    MenuItem,
    Select,
    SelectChangeEvent,
    Typography,
    useAppSelector,
    useTheme,
} from '../../../base';
import { dashboardSelectors } from '../../../actions';
import { DASHBOARD_TIME_RANGES, getTimeElapsedString } from '../../../common';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface TopBarComponentProps {
    timeRange: IOption;
    onTimeRangeChange: (event: SelectChangeEvent<unknown>) => void;
    onRefresh: () => void;
}

const TopBarComponent = ({
    timeRange,
    onTimeRangeChange,
    onRefresh,
}: TopBarComponentProps) => {
    const lastUpdated = useAppSelector(dashboardSelectors.getLastUpdated);
    const [lastUpdatedText, setLastUpdatedText] = useState<string>(
        getTimeElapsedString(lastUpdated)
    );
    const { t } = useTranslation();
    const theme = useTheme();

    useEffect(() => {
        setLastUpdatedText(getTimeElapsedString(lastUpdated));

        const intervalId = setInterval(() => {
            setLastUpdatedText(getTimeElapsedString(lastUpdated));
        }, 60000);

        return () => clearInterval(intervalId);
    }, [lastUpdated]);

    const handleRefreshClick = () => {
        onRefresh();
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h5">
                    {t('dashboardPage.keyMetrics')}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                    sx={{
                        marginInlineEnd: theme.spacing(0.5),
                        height: '30px',
                        width: '30px',
                    }}
                    onClick={handleRefreshClick}
                >
                    <Icon name="SyncOutlineIcon" size={10} />
                </IconButton>
                <Typography
                    variant="body2"
                    color={theme.palette.text.secondary}
                    sx={{ marginInlineEnd: 1 }}
                >
                    {lastUpdatedText}
                </Typography>
                <Select
                    value={timeRange.value}
                    onChange={onTimeRangeChange}
                    size="small"
                    sx={{ minWidth: 120 }}
                >
                    <MenuItem value={DASHBOARD_TIME_RANGES.WEEK}>
                        {t('dashboardPage.week')}
                    </MenuItem>
                    <MenuItem value={DASHBOARD_TIME_RANGES.MONTH}>
                        {t('dashboardPage.month')}
                    </MenuItem>
                    <MenuItem value={DASHBOARD_TIME_RANGES.QUARTER}>
                        {t('dashboardPage.quarter')}
                    </MenuItem>
                    <MenuItem value={DASHBOARD_TIME_RANGES.YEAR}>
                        {t('dashboardPage.year')}
                    </MenuItem>
                </Select>
            </Box>
        </Box>
    );
};

export default TopBarComponent;
